<template>
  <section class="service-detail">
    <div class="container">
      <div class="back-button" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> Back to Services
      </div>
      
      <div class="section-title" v-if="service">
        <h2>{{ service.title }}</h2>
        <p>{{ service.fullDescription }}</p>
      </div>
      
      <div class="detail-content" v-if="service">
        <div class="detail-image">
          <i :class="service.icon"></i>
        </div>
        
        <div class="detail-text">
          <h3>How It Works</h3>
          <p>{{ service.howItWorks }}</p>
          
          <div class="detail-features">
            <h4>Key Features</h4>
            <ul>
              <li v-for="feature in service.detailFeatures" :key="feature">{{ feature }}</li>
            </ul>
          </div>
          
          <div class="form-buttons" style="margin-top: 30px;">
            <button class="btn-primary">Get Started</button>
            <button class="btn-secondary" @click="$router.go(-1)">Back to Services</button>
          </div>
        </div>
      </div>
      
      <div v-else class="loading">
        <p>Loading service details...</p>
      </div>
    </div>
  </section>
</template>

<script>
// Mock API (在实际项目中应该从API获取)
const mockApi = {
  getServiceDetail: function(serviceId) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const services = {
          'market-overview': {
            id: 'market-overview',
            title: 'Entering the Chinese and Southeast Asian Markets',
            icon: 'fas fa-globe-asia',
            fullDescription: 'Comprehensive solutions for entering Chinese and Southeast Asian markets with our intelligent diagnosis, market entry support, and partnership facilitation services.',
            howItWorks: 'Our integrated approach begins with a thorough market diagnosis to identify the best opportunities for your business. We then provide comprehensive market entry support, including policy interpretation, compliance registration, and inspection tours. Finally, we facilitate partnerships with reliable suppliers, distributors, and other business partners in the region.',
            detailFeatures: [
              'Intelligent market diagnosis and recommendation',
              'Comprehensive market entry planning',
              'Policy interpretation and compliance assistance',
              'Market inspection tour arrangement',
              'Supplier and distributor identification',
              'Partnership facilitation and contract support',
              'Ongoing market monitoring and support'
            ]
          },
          'market-diagnosis': {
            id: 'market-diagnosis',
            title: 'Market Diagnosis',
            icon: 'fas fa-search',
            fullDescription: 'Comprehensive market analysis to identify the best opportunities for your business in international markets.',
            howItWorks: 'Our market diagnosis service begins with an in-depth analysis of your business, products, and objectives. We then leverage our extensive database of market intelligence to identify the most suitable countries and cities for your expansion. The process includes competitive analysis, consumer insights, market sizing, and risk assessment.',
            detailFeatures: [
              'Detailed market analysis report',
              'Competitive landscape assessment',
              'Consumer behavior insights',
              'Regulatory environment overview',
              'Risk assessment and mitigation strategies',
              'Customized market entry recommendations'
            ]
          },
          'market-entry': {
            id: 'market-entry',
            title: 'Market Entry & Inspection',
            icon: 'fas fa-plane',
            fullDescription: 'Comprehensive support for entering new markets with policy interpretation and compliance registration.',
            howItWorks: 'Our market entry service provides end-to-end support for your international expansion. We handle everything from policy interpretation and compliance registration to arranging market inspection tours. Our team of experts will guide you through the entire process, ensuring a smooth and successful market entry.',
            detailFeatures: [
              'Policy interpretation and guidance',
              'Compliance registration assistance',
              'Industrial park recommendations',
              'Market inspection tour arrangement',
              'Local partner identification',
              'Logistics and supply chain setup'
            ]
          },
          'partnership': {
            id: 'partnership',
            title: 'Partnership Facilitation',
            icon: 'fas fa-handshake',
            fullDescription: 'Connect with reliable partners, distributors, and suppliers in your target markets.',
            howItWorks: 'Our partnership facilitation service connects you with reliable partners, distributors, and suppliers in your target markets. We leverage our extensive network of business contacts and our platform\'s accumulated enterprise resource pool to identify the best matches for your business needs.',
            detailFeatures: [
              'Supplier identification and vetting',
              'Distributor matching',
              'Joint venture facilitation',
              'Contract negotiation support',
              'Partnership performance monitoring',
              'Access to our enterprise resource pool'
            ]
          }
        }
        
        resolve(services[serviceId] || null)
      }, 1000)
    })
  }
}

export default {
  name: 'ServiceDetail',
  props: ['id'],
  data() {
    return {
      service: null
    }
  },
  async created() {
    this.service = await mockApi.getServiceDetail(this.id)
  },
  watch: {
    id: {
      async handler(newId) {
        this.service = await mockApi.getServiceDetail(newId)
      }
    }
  }
}
</script>

<style scoped>
.service-detail {
  padding: 80px 0;
  background-color: white;
}

.back-button {
  display: inline-flex;
  align-items: center;
  margin-bottom: 30px;
  color: #4dabf7;
  font-weight: 500;
  cursor: pointer;
}

.back-button i {
  margin-right: 8px;
}

.detail-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-top: 30px;
}

.detail-image {
  background: linear-gradient(135deg, #4dabf7 0%, #1a3a5f 100%);
  border-radius: 8px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 60px;
}

.detail-text h3 {
  color: #1a3a5f;
  margin-bottom: 20px;
}

.detail-text p {
  margin-bottom: 15px;
}

.detail-features {
  margin-top: 30px;
}

.detail-features h4 {
  color: #1a3a5f;
  margin-bottom: 15px;
}

.detail-features ul {
  list-style: none;
}

.detail-features li {
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
}

.detail-features li:before {
  content: "•";
  color: #4dabf7;
  font-weight: bold;
  position: absolute;
  left: 0;
}

.loading {
  text-align: center;
  padding: 50px 0;
}

@media (max-width: 992px) {
  .detail-content {
    grid-template-columns: 1fr;
  }
}
</style>